// extracted by mini-css-extract-plugin
module.exports = {"VideoCard":"YoutubeScript_VideoCard__GId6B","EmbedContainer":"YoutubeScript_EmbedContainer__3ZBZl"};